module.exports = __webpack_public_path__ + "img/pat_02.c7ca830e.jpg";